import { Controller } from "@hotwired/stimulus"

// The Business Overview section's in-line industry select. The select is
// nameless (never part of the discovery form's autosave); changing it PATCHes
// Sales::IndustriesController, whose turbo_stream response re-renders the
// discovery tab with that industry's specific questions swapped in.
export default class extends Controller {
  static values = { url: String }

  async save() {
    const body = new FormData()
    body.append("sales_opportunity[industry]", this.element.value)

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Accept": "text/vnd.turbo-stream.html",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || "",
          "X-Requested-With": "XMLHttpRequest"
        },
        body,
        credentials: "same-origin"
      })
      if (response.ok) Turbo.renderStreamMessage(await response.text())
    } catch {
      // Leave the select as-is; the next full save or reload reconciles it.
    }
  }
}
